export default {
  "b2b.auth.unauthorized.first-row": "You have insufficient rights",
  "b2b.auth.unauthorized.second-row":
    "Please contact Customer Services Department of the Test Centre"
};
